import { type FunctionComponent } from 'react';

import { Button, Icon, Text } from '@kanda-libs/ks-design-library';

import useOmniSignDocumentsFormBasePageActionBar from './useOmniSignDocumentsFormBasePageActionBar';

import { BaseDocument } from '../useOmniSignDocumentsFormBasePage';

interface OmniSignDocumentsFormBasePageActionBar {
  document?: BaseDocument;
}

const OmniSignDocumentsFormBasePageActionBar: FunctionComponent<
  OmniSignDocumentsFormBasePageActionBar
> = ({ document }) => {
  const { onDownloadClick, onPrintClick } =
    useOmniSignDocumentsFormBasePageActionBar(document);
  return (
    <div className="flex flex-col px-4 py-5 border border-neutral-300 rounded bg-neutral-100">
      <div className="flex flex-row mb-4">
        <div className="flex my-auto w-6 h-6 min-w-6 min-h-6 bg-lavender-100 rounded-full mr-3">
          <Icon
            icon="check"
            size={16}
            className="m-auto"
            stroke="lavender-300"
          />
        </div>
        <Text
          text="We strongly suggest that you save the contract for your own records"
          className="text-12-18-em text-lavender-200 w-full"
          skeletonProps={{
            width: '100%',
            count: 2,
          }}
        />
      </div>
      <div className="flex flex-row justify-between">
        <Button.Link
          id="sign-documents-download"
          label="Download"
          icon="download"
          left
          variant="grey"
          className="w-1/3"
          size={14}
          onClick={onDownloadClick}
        />
        <Button.Link
          id="sign-documents-print"
          label="Print"
          icon="note"
          left
          variant="grey"
          className="w-1/3"
          size={14}
          onClick={onPrintClick}
        />
      </div>
    </div>
  );
};

export default OmniSignDocumentsFormBasePageActionBar;
